import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { ApiService } from './api.service';
import { PagedResults } from 'app/core/models/paged-results/paged-results.model';
import { LimitOffsetPaging, LimitOffsetPagingMeta } from 'app/core/models/paged-results/limit-offset-paging.model';
import { EncounterTypeEligibilitySummary } from '../models/encounter-type-eligibility-summary.model';
import { EncounterTypeEligibilityFilters } from '../models/user-settings/encounter-type-eligibility-settings.model';

export class PagedEncounterTypeEligibilitySummary implements PagedResults {
  encounterTypeEligibilitySummaries: EncounterTypeEligibilitySummary[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.encounterTypeEligibilitySummaries;
  }
}

@Injectable()
export class EncounterTypeEligibilitiesService extends ApiService {
  private http = inject(HttpClient);

  getSummaryList(
    paging: LimitOffsetPaging = null,
    filters: EncounterTypeEligibilityFilters = null
  ): Observable<PagedEncounterTypeEligibilitySummary> {
    const params = new URLSearchParams();

    if (paging) {
      params.append('page', paging.currentPage.toString());
      params.append('per_page', paging.pageSize.toString());
    }

    if (filters) {
      if (filters.clientIds) {
        filters.clientIds.forEach(clientId => params.append('client_ids[]', clientId));
      }

      if (filters.assignedClientLeadUserIds) {
        filters.assignedClientLeadUserIds.forEach(userId=> params.append('assigned_client_leads_ids[]', userId));
      }

      if (filters.clientEntityTypes) {
        filters.clientEntityTypes.forEach(entityType => params.append('client_entity_types[]', entityType));
      }

      if (filters.eligibilityStatuses) {
        filters.
          eligibilityStatuses.
          forEach(eligibilityStatus => params.append('eligibility_statuses[]', eligibilityStatus));
      }
    }

    return this.http.get<PagedEncounterTypeEligibilitySummary>(`${environment.captureApi.url}/encounter_type_eligibilities?${params.toString()}`);
  }

  markAsEligible(summary: EncounterTypeEligibilitySummary) {
    const { clientId, encounterType } = summary;

    return this.http.post(`${environment.captureApi.url}/encounter_type_eligibilities/eligible`, {
      clientId,
      encounterType
    });
  }

  markAsIneligible(summary: EncounterTypeEligibilitySummary) {
    const { clientId, encounterType } = summary;

    return this.http.post(`${environment.captureApi.url}/encounter_type_eligibilities/ineligible`, {
      clientId,
      encounterType
    });
  }
}
